(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-vlow"] = factory();
	else
		root["vue-vlow"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0ea7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VlowCanvas_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("690f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VlowCanvas_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VlowCanvas_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2661":
/***/ (function(module, exports) {

module.exports = [{"id":"entry","title":"entry","template_types":{"A":"Any"},"inputs":{},"outputs":{"out":{"label":" ","type":"(Void)"}}},{"id":"finish","title":"finish","template_types":{},"inputs":{"return":{"type":"(Int)"}},"outputs":{}},{"id":"mapToValue","title":"mapToValue","template_types":{"A":"Any","B":"Any"},"inputs":{"$0":{"label":" ","type":"A"},"$1":{"label":"value","type":"B"}},"outputs":{"out":{"label":" ","type":"(B)"}}},{"title":"stride","id":"stride","template_types":{"A":"Any"},"inputs":{"from":{"type":"(A)"},"to":{"type":"(A)"},"by":{"type":"(A)"}},"outputs":{"out":{"label":" ","type":"(A)"}}},{"id":"mapValues","title":"mapValues","template_types":{"A":"Any","B":"Any"},"inputs":{"array":"Array<A>"},"passthroughs":{"element":{"type":"A"}},"collects":{"result":{"type":"B"}},"outputs":{"ret":{"label":" ","type":"Array<B>"}}},{"id":"modulo","title":"%","template_types":{"A":"Numeric"},"inputs":{"a":{"label":" ","type":"(A)"},"b":{"label":" ","type":"(A)"}},"outputs":{"out":{"label":" ","type":"(A)"}}},{"id":"decisionTable","title":"decisionTable","inputs":{"$0":{"type":"Bool"},"$1":{"type":"Bool"}},"outputs":{"ret":{"label":" ","type":"Cases<N>"}}},{"id":"select","title":"select","template_types":{"A":"Any"},"inputs":{"v_":{"label":" ","type":"Cases<N>"},"v0":{"label":"0","type":"A"},"v1":{"label":"1","type":"A"},"v2":{"label":"2","type":"A"},"v3":{"label":"3","type":"A"}},"outputs":{"ret":{"label":" ","type":"A"}}},{"id":"forEach","title":"forEach","template_types":{"A":"Any"},"inputs":{"array":{"type":"Array<A>"}},"passthroughs":{"element":{"type":"A"}}},{"id":"print","title":"print","template_types":{"A":"Stringy"},"inputs":{"string":{"type":"A"}}},{"id":"stringInterpolation","title":"fmt","template_types":{"A":"Any"},"inputs":{"$0":{"label":" ","type":"A"}},"outputs":{"ret":{"label":" ","type":"String"}}}]

/***/ }),

/***/ "4f25":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

__webpack_require__("8531");

/**
 * \\ - matches the backslash which indicates the beginning of an escape sequence
 * (
 *   u\{([0-9A-Fa-f]+)\} - first alternative; matches the variable-length hexadecimal escape sequence (\u{ABCD0})
 * |
 *   u([0-9A-Fa-f]{4}) - second alternative; matches the 4-digit hexadecimal escape sequence (\uABCD)
 * |
 *   x([0-9A-Fa-f]{2}) - third alternative; matches the 2-digit hexadecimal escape sequence (\xA5)
 * |
 *   ([1-7][0-7]{0,2}|[0-7]{2,3}) - fourth alternative; matches the up-to-3-digit octal escape sequence (\5 or \512)
 * |
 *   (['"tbrnfv0\\]) - fifth alternative; matches the special escape characters (\t, \n and so on)
 * |
 *   \U([0-9A-Fa-f]+) - sixth alternative; matches the 8-digit hexadecimal escape sequence used by python (\U0001F3B5)
 * )
 */
var jsEscapeRegex = /\\(u\{([0-9A-Fa-f]+)\}|u([0-9A-Fa-f]{4})|x([0-9A-Fa-f]{2})|([1-7][0-7]{0,2}|[0-7]{2,3})|(['"tbrnfv0\\]))|\\U([0-9A-Fa-f]{8})/g;
var usualEscapeSequences = {
  '0': '\0',
  'b': '\b',
  'f': '\f',
  'n': '\n',
  'r': '\r',
  't': '\t',
  'v': '\v',
  '\'': '\'',
  '"': '"',
  '\\': '\\'
};

var fromHex = function fromHex(str) {
  return String.fromCodePoint(parseInt(str, 16));
};

var fromOct = function fromOct(str) {
  return String.fromCodePoint(parseInt(str, 8));
};

var _default = function _default(string) {
  return string.replace(jsEscapeRegex, function (_, __, varHex, longHex, shortHex, octal, specialCharacter, python) {
    if (varHex !== undefined) {
      return fromHex(varHex);
    } else if (longHex !== undefined) {
      return fromHex(longHex);
    } else if (shortHex !== undefined) {
      return fromHex(shortHex);
    } else if (octal !== undefined) {
      return fromOct(octal);
    } else if (python !== undefined) {
      return fromHex(python);
    } else {
      return usualEscapeSequences[specialCharacter];
    }
  });
};

exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ "690f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7749":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// < begin copyright > 
// Copyright Ryan Marcus 2018
// 
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
// 
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
// 
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// 
// < end copyright > 
 


let lexer = __webpack_require__("a778");

// terminals
const LEX_KV = 0;
const LEX_KVLIST = 1;
const LEX_VLIST = 2;
const LEX_BOOLEAN = 3;
const LEX_COVALUE = 4;
const LEX_CVALUE = 5;
const LEX_FLOAT = 6;
const LEX_INT = 7;
const LEX_KEY = 8;
const LEX_LIST = 9;
const LEX_OBJ = 10;
const LEX_QUOTE = 11;
const LEX_RB = 12;
const LEX_RCB = 13;
const LEX_TOKEN = 14;
const LEX_VALUE = 15;

// non-terminals
const LEX_COLON = -1;
const LEX_COMMA = -2;
const LEX_LCB = -3;
const LEX_LB = -4;
const LEX_DOT = -5;

function extendArray(arr) {
    if (arr.peek == null) {
        Object.defineProperty(arr, 'peek', {
            enumerable: false,
            value: function() {
                return this[this.length - 1];
            }
        });
    }
    if (arr.last == null) {
        Object.defineProperty(arr, 'last', {
            enumerable: false,
            value: function(i) {
                return this[this.length - (1 + i)];
            }
        });
    }
}

function is(obj, prop) {
    return (obj && obj.hasOwnProperty("type") && obj.type == prop);
}

function log(str) {
    //console.log(str);
}


module.exports.parse = parse;
function parse(text, dupKeys) {
    let stack = [];

    let tokens = [];

    extendArray(stack);
    extendArray(tokens);

    let emit = function(t) {
        tokens.push(t);
    };

    lexer.lexString(text, emit);

    // ensure that if we started with a LB or LCB, we end with a
    // RB or RCB.
    if (tokens[0].type == LEX_LB && tokens.last(0).type != LEX_RB) {
        tokens.push({ type: LEX_RB, value: "]", row: -1, col: -1});
    }

    if (tokens[0].type == LEX_LCB && tokens.last(0).type != LEX_RCB) {
        tokens.push({ type: LEX_RCB, value: "}", row: -1, col: -1});
    }

    for (let i = 0; i < tokens.length; i++) {
        log("Shifting " + tokens[i].type);
        stack.push(tokens[i]);
        log(stack);
        log("Reducing...");
        while (reduce(stack)) {
            log(stack);
            log("Reducing...");
        }
    }

    // if everything parsed into a KV list, assume it was an object missing the starting
    // "{" and ending "}"
    if (stack.length == 1 && stack[0].type == LEX_KVLIST) {
        log("Pre-compile error fix 1");
        stack = [{type: LEX_OBJ, value: stack[0].value}];
    }

    return compileOST(stack[0], dupKeys);

}

function reduce(stack) {
    let next = stack.pop();

    switch(next.type) {
    case LEX_KEY:
        if (next.value.trim() == "true") {
            log("Rule 5");
            stack.push({'type': LEX_BOOLEAN, 'value': "true"});
            return true;
        }


        if (next.value.trim() == "false") {
            log("Rule 6");
            stack.push({'type': LEX_BOOLEAN, 'value': "false"});
            return true;
        }

        if (next.value.trim() == "null") {
            log("Rule 7");
            stack.push({'type': LEX_VALUE, 'value': null});
            return true;
        }
        break;

    case LEX_TOKEN:
        if (is(stack.peek(), LEX_KEY)) {
            log("Rule 11a");
            stack.peek().value += next.value;
            return true;
        }

        log("Rule 11c");
        stack.push({type: LEX_KEY, value: next.value });
        return true;


    case LEX_INT:
        if (is(next, LEX_INT) && is(stack.peek(), LEX_KEY)) {
            log("Rule 11b");
            stack.peek().value += next.value;
            return true;
        }

        log("Rule 11f");
        next.type = LEX_VALUE;
        stack.push(next);
        return true;


    case LEX_QUOTE:
        log("Rule 11d");
        next.type = LEX_VALUE;
        next.value = next.value;
        stack.push(next);
        return true;


    case LEX_BOOLEAN:
        log("Rule 11e");
        next.type = LEX_VALUE;

        if (next.value == "true") {
            next.value = true;
        } else {
            next.value = false;
        }

        stack.push(next);
        return true;


    case LEX_FLOAT:
        log("Rule 11g");
        next.type = LEX_VALUE;
        stack.push(next);
        return true;

    case LEX_VALUE:
        if (is(stack.peek(), LEX_COMMA)) {
            log("Rule 12");
            next.type = LEX_CVALUE;
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_COLON)) {
            log("Rule 13");
            next.type = LEX_COVALUE;
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_VALUE)) {
            log("Error rule 1");
            let middleVal = stack.pop();
            stack.peek().value += '"' + middleVal.value + '"';
            stack.peek().value += next.value;
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_VLIST)) {
            log("Error rule 2");
            let middleVal = stack.pop();
            let oldLastVal = stack.peek().value.pop();
            oldLastVal +=  '"' + middleVal.value + '"';
            oldLastVal += next.value;
            
            stack.peek().value.push(oldLastVal);
            
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_KVLIST)) {
            log("Error rule 3");
            let middleVal = stack.pop();
            let oldLastVal = stack.peek().value.pop();
            const qChar = next.single ? "'" : '"';
            
            oldLastVal.value +=  qChar + middleVal.value + qChar;
            oldLastVal.value += next.value;
            
            stack.peek().value.push(oldLastVal);
            
            return true;
        }

        if (is(stack.peek(), LEX_KEY)) {
            log("Error rule 4");
            let keyValue = stack.pop().value;
            next.value = keyValue + next.value;
            stack.push(next);
            return true;
        }

        break;

    case LEX_LIST:
        if (is(next, LEX_LIST) && is(stack.peek(), LEX_COMMA)) {
            log("Rule 12a");
            next.type = LEX_CVALUE;
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_COLON)) {
            log("Rule 13a");
            next.type = LEX_COVALUE;
            stack.pop();
            stack.push(next);
            return true;
        }
        break;

    case LEX_OBJ:
        if (is(stack.peek(), LEX_COMMA)) {
            log("Rule 12b");
            let toPush = {'type': LEX_CVALUE, 'value': next};
            stack.pop();
            stack.push(toPush);
            return true;
        }

        if (is(stack.peek(), LEX_COLON)) {
            log("Rule 13b");
            let toPush = {'type': LEX_COVALUE, 'value': next};
            stack.pop();
            stack.push(toPush);
            return true;
        }

        if (is(stack.peek(), LEX_KEY)) {
            log("Error rule 9");
            let key = stack.pop();
            stack.push({'type': LEX_KV, 'key': key.value.trim(), 'value': next});
            return true;
        }
        
        break;

    case LEX_CVALUE:
        if (is(stack.peek(), LEX_VLIST)) {
            log("Rule 14");
            stack.peek().value.push(next.value);
            return true;
        }


        log("Rule 15");
        stack.push({'type': LEX_VLIST, 'value': [next.value]});
        return true;

    case LEX_VLIST:
        if (is(stack.peek(), LEX_VALUE)) {
            log("Rule 15a");
            next.value.unshift(stack.peek().value);
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_LIST)) {
            log("Rule 15b");
            next.value.unshift(stack.peek().value);
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_OBJ)) {
            log("Rule 15c");
            next.value.unshift(stack.peek());
            stack.pop();
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && (stack.last(1), LEX_COMMA)) {
            log("Error rule 7");
            let l = stack.pop();
            stack.push({type: LEX_VALUE, 'value': l.value});
            log("Start subreduce... (" + l.value + ")");
            while(reduce(stack));
            log("End subreduce");
            stack.push(next);

            return true;
        }

        if (is(stack.peek(), LEX_VLIST)) {
            log("Error rule 8");
            stack.peek().value.push(next.value[0]);
            return true;
        }
        break;

    case LEX_COVALUE:

        if (is(stack.peek(), LEX_KEY) || is(stack.peek(), LEX_VALUE) || is(stack.peek(), LEX_VLIST)) {
            log("Rule 16");
            let key = stack.pop();
            stack.push({'type': LEX_KV, 'key': key.value, 'value': next.value});
            return true;
        }


        throw new Error("Got a :value that can't be handled at line " +
                       next.row + ":" + next.col);

    case LEX_KV:
        if (is(stack.last(0), LEX_COMMA) && is(stack.last(1), LEX_KVLIST)) {
            log("Rule 17");
            stack.last(1).value.push(next);
            stack.pop();
            return true;
        }

        log("Rule 18");
        stack.push({'type': LEX_KVLIST, 'value': [next]});
        return true;

    case LEX_KVLIST:
        if (is(stack.peek(), LEX_KVLIST)) {
            log("Rule 17a");
            next.value.forEach(function (i) {
                stack.peek().value.push(i);
            });
            return true;
        }

        break;

    case LEX_RB:
        if (is(stack.peek(), LEX_VLIST) && is(stack.last(1), LEX_LB)) {
            log("Rule 19");
            let l = stack.pop();
            stack.pop();
            stack.push({'type': LEX_LIST, 'value': l.value});
            return true;
        }

        if (is(stack.peek(), LEX_LIST) && is(stack.last(1), LEX_LB)) {
            log("Rule 19b");
            let l = stack.pop();
            stack.pop();
            stack.push({'type': LEX_LIST, 'value': [l.value]});
            return true;
        }

        if (is(stack.peek(), LEX_LB)) {
            log("Rule 22");
            stack.pop();
            stack.push({type: LEX_LIST, 'value': []});
            return true;
        }

        if (is(stack.peek(), LEX_VALUE) && is(stack.last(1), LEX_LB)) {
            log("Rule 23");
            let val = stack.pop().value;
            stack.pop();
            stack.push({type: LEX_LIST, 'value': [val]});
            return true;
        }

        if (is(stack.peek(), LEX_OBJ) && is(stack.last(1), LEX_LB)) {
            log("Rule 23b");
            let val = stack.pop();
            stack.pop();
            stack.push({type: LEX_LIST, 'value': [val]});
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_COMMA)) {
            log("Error rule 5");
            let l = stack.pop();
            stack.push({type: LEX_VALUE, 'value': l.value});
            log("Start subreduce... (" + l.value + ")");
            while(reduce(stack));
            log("End subreduce");
            stack.push({type: LEX_RB});
            return true;
        }

        
        if (is(stack.peek(), LEX_COMMA) && (
            is(stack.last(1), LEX_KEY)
                || is(stack.last(1), LEX_OBJ)
                || is(stack.last(1), LEX_VALUE))
           ) {
            log("Error rule 5a");
            stack.pop();
            //let l = stack.pop();
            //stack.push({type: LEX_VALUE, 'value': l.value});
            stack.push({type: LEX_RB, 'value': ']'});
            log("Start subreduce...");
            log("Content: " + JSON.stringify(stack));
            while(reduce(stack));
            log("End subreduce");

            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_LB)) {
            log("Error rule 5b");
            let v = stack.pop();
            stack.pop();
            stack.push({type: LEX_LIST, value: [v.value]});
            return true;
        }

        if (is(stack.peek(), LEX_COMMA) && is(stack.last(1), LEX_VLIST)) {
            log("Error rule 5c");
            stack.pop();
            stack.push({type: LEX_RB});
            log("Start subreduce...");
            log("Content: " + JSON.stringify(stack));
            while(reduce(stack));
            log("End subreduce");

            return true;
        }

        break;

    case LEX_RCB:
        if (is(stack.peek(), LEX_KVLIST) && is(stack.last(1), LEX_LCB)) {
            log("Rule 20");
            let l = stack.pop();
            stack.pop();
            stack.push({'type': LEX_OBJ, 'value': l.value});
            return true;
        }

        if (is(stack.peek(), LEX_LCB)) {
            log("Rule 21");
            stack.pop();
            stack.push({type: LEX_OBJ, 'value': null});
            return true;
        }

        if (is(stack.peek(), LEX_KEY) && is(stack.last(1), LEX_COLON)) {
            log("Error rule 4a");
            let l = stack.pop();
            stack.push({type: LEX_VALUE, 'value': l.value});
            log("Start subreduce... (" + l.value + ")");
            while(reduce(stack));
            log("End subreduce");
            stack.push({type: LEX_RCB});
            return true;
        }

        if (is(stack.peek(), LEX_COLON)) {
            log("Error rule 4b");
            stack.push({type: LEX_VALUE, value: null});

            log("Starting subreduce...");
            while (reduce(stack));
            log("End subreduce.");
            
            stack.push({type: LEX_RCB});
            return true;
        }

        if (is(stack.peek(), LEX_COMMA)) {
            log("Error rule 10a");
            stack.pop();
            stack.push({type: LEX_RCB});
            return true;
        }
        
        throw new Error("Found } that I can't handle at line " +
                        next.row + ":" + next.col);

        
    case LEX_COMMA:
        if (is(stack.peek(), LEX_COMMA)) {
            log("Comma error rule 1");
            // do nothing -- so don't push the extra comma onto the stack
            return true;
        }

        if (is(stack.peek(), LEX_KEY)) {
            log("Comma error rule 2");
            const key = stack.pop();
            stack.push({type: LEX_VALUE, value: key.value});
            
            log("Starting subreduce...");
            while (reduce(stack));
            log ("End subreduce.");
            
            stack.push(next);
            return true;
        }

        if (is(stack.peek(), LEX_COLON)) {
            log("Comma error rule 3");
            stack.push({type: LEX_VALUE, value: null});
            
            log("Starting subreduce...");
            while (reduce(stack));
            log ("End subreduce.");
            
            stack.push(next);
            return true;
        }

    }


    stack.push(next);
    return false;
}



function compileOST(tree, dupKeys) {
    let rawTypes = ["boolean", "number", "string"];

    if (rawTypes.indexOf((typeof tree)) != -1)
        return tree;

    if (tree === null)
        return null;

    if (Array.isArray(tree)) {
        let toR = [];
        while (tree.length > 0)
            toR.unshift(compileOST(tree.pop()));
        return toR;
    }
    

    if (is(tree, LEX_OBJ)) {
        let toR = {};
        if (tree.value === null)
            return {};
        tree.value.forEach(function (i) {
            const key = i.key;
            const val = compileOST(i.value);

            if (dupKeys && key in toR) {
                toR[key] = {
                    "value": toR[key],
                    "next": val
                };
            } else {
                toR[key] = val;
            }
        });
        return toR;
    }

    if (is(tree, LEX_LIST)) {
        return compileOST(tree.value);
    }

    // it must be a value
    return tree.value;
}



/***/ }),

/***/ "7e68":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8326":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// < begin copyright > 
// Copyright Ryan Marcus 2018
// 
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
// 
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
// 
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// 
// < end copyright > 
 




let parser = __webpack_require__("7749");

module.exports.parse = parse;
function parse(text, config) {
    let fallback = true;
    let duplicateKeys = false;

    if (config) {
        if (("fallback" in config) && config[fallback] === false) {
            fallback = false;
        }

        duplicateKeys = "duplicateKeys" in config && config["duplicateKeys"] === true;
    }

    try {
        return parser.parse(text, duplicateKeys);
    } catch (e) {
        // our parser threw an error! see if the JSON was valid...
        /* istanbul ignore next */
        if (fallback === false) {
            throw e;
        }
        
        try {
            let json = JSON.parse(text);
            // if we didn't throw, it was valid JSON!
            /* istanbul ignore next */
            console.warn("dirty-json got valid JSON that failed with the custom parser. We're returning the valid JSON, but please file a bug report here: https://github.com/RyanMarcus/dirty-json/issues  -- the JSON that caused the failure was: " + text);

            /* istanbul ignore next */
            return json;
        } catch (json_error) {
            throw e;
        }

    }
}


/***/ }),

/***/ "8531":
/***/ (function(module, exports) {

/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */
if (!String.fromCodePoint) {
	(function() {
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var stringFromCharCode = String.fromCharCode;
		var floor = Math.floor;
		var fromCodePoint = function(_) {
			var MAX_SIZE = 0x4000;
			var codeUnits = [];
			var highSurrogate;
			var lowSurrogate;
			var index = -1;
			var length = arguments.length;
			if (!length) {
				return '';
			}
			var result = '';
			while (++index < length) {
				var codePoint = Number(arguments[index]);
				if (
					!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
					codePoint < 0 || // not a valid Unicode code point
					codePoint > 0x10FFFF || // not a valid Unicode code point
					floor(codePoint) != codePoint // not an integer
				) {
					throw RangeError('Invalid code point: ' + codePoint);
				}
				if (codePoint <= 0xFFFF) { // BMP code point
					codeUnits.push(codePoint);
				} else { // Astral code point; split in surrogate halves
					// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
					codePoint -= 0x10000;
					highSurrogate = (codePoint >> 10) + 0xD800;
					lowSurrogate = (codePoint % 0x400) + 0xDC00;
					codeUnits.push(highSurrogate, lowSurrogate);
				}
				if (index + 1 == length || codeUnits.length > MAX_SIZE) {
					result += stringFromCharCode.apply(null, codeUnits);
					codeUnits.length = 0;
				}
			}
			return result;
		};
		if (defineProperty) {
			defineProperty(String, 'fromCodePoint', {
				'value': fromCodePoint,
				'configurable': true,
				'writable': true
			});
		} else {
			String.fromCodePoint = fromCodePoint;
		}
	}());
}


/***/ }),

/***/ "861d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("89c1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Node_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "87d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecisionTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7e68");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecisionTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecisionTable_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "89c1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a778":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// < begin copyright > 
// Copyright Ryan Marcus 2018
// 
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
// 
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
// 
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// 
// < end copyright > 
 


const Lexer = __webpack_require__("c2a4");
const unescapeJs = __webpack_require__("4f25");
const utf8 = __webpack_require__("f1dd");

// terminals
const LEX_KV = 0;
const LEX_KVLIST = 1;
const LEX_VLIST = 2;
const LEX_BOOLEAN = 3;
const LEX_COVALUE = 4;
const LEX_CVALUE = 5;
const LEX_FLOAT = 6;
const LEX_INT = 7;
const LEX_KEY = 8;
const LEX_LIST = 9;
const LEX_OBJ = 10;
const LEX_QUOTE = 11;
const LEX_RB = 12;
const LEX_RCB = 13;
const LEX_TOKEN = 14;
const LEX_VALUE = 15;

// non-terminals
const LEX_COLON = -1;
const LEX_COMMA = -2;
const LEX_LCB = -3;
const LEX_LB = -4;
const LEX_DOT = -5;


const lexMap = {
    ":": {type: LEX_COLON},
    ",": {type: LEX_COMMA},
    "{": {type: LEX_LCB},
    "}": {type: LEX_RCB},
    "[": {type: LEX_LB},
    "]": {type: LEX_RB},
    ".": {type: LEX_DOT} // TODO: remove?
};

const lexSpc = [
    [/\s*:\s*/, LEX_COLON],
    [/\s*,\s*/, LEX_COMMA],
    [/\s*{\s*/, LEX_LCB],
    [/\s*}\s*/, LEX_RCB],
    [/\s*\[\s*/, LEX_LB],
    [/\s*\]\s*/, LEX_RB],
    [/\s*\.\s*/, LEX_DOT] // TODO: remove?
];

function parseString(str) {
    // unescape-js doesn't cover the \/ case, but we will here.
    str = str.replace(/\\\//, '/');
    return unescapeJs(str);
}


function getLexer(string) {
    let lexer = new Lexer();

    let col = 0;
    let row = 0;
    
    lexer.addRule(/"((?:\\.|[^"])*?)($|")/, (lexeme, txt) => {
        col += lexeme.length;
        return {type: LEX_QUOTE, value: parseString(txt), row, col, single: false};
    });

    lexer.addRule(/'((?:\\.|[^'])*?)($|'|(",?[ \t]*\n))/, (lexeme, txt) => {
        col += lexeme.length;
        return {type: LEX_QUOTE, value: parseString(txt), row, col, single: true};
    });

    // floats with a dot
    lexer.addRule(/[\-0-9]*\.[0-9]*([eE][\+\-]?)?[0-9]*(?:\s*)/, lexeme => {
        col += lexeme.length;
        return {type: LEX_FLOAT, value: parseFloat(lexeme), row, col};
    });

    // floats without a dot but with e notation
    lexer.addRule(/\-?[0-9]+([eE][\+\-]?)[0-9]*(?:\s*)/, lexeme => {
        col += lexeme.length;
        return {type: LEX_FLOAT, value: parseFloat(lexeme), row, col};
    });
    
    lexer.addRule(/\-?[0-9]+(?:\s*)/, lexeme => {
        col += lexeme.length;
        return {type: LEX_INT, value: parseInt(lexeme), row, col};
    });

    lexSpc.forEach(item => {
        lexer.addRule(item[0], lexeme => {
            col += lexeme.length;
            return {type: item[1], value: lexeme, row, col};
        });
    });

    lexer.addRule(/\s/, lexeme => {
        // chomp whitespace...
        if (lexeme == "\n") {
            col = 0;
            row++;
        } else {
            col += lexeme.length;
        }
    });

    
    lexer.addRule(/\S[ \t]*/, lexeme => {
        col += lexeme.length;
        
        let lt = LEX_TOKEN;
        let val = lexeme;
        
        return {type: lt, value: val, row, col};
    });
    



    lexer.setInput(string);

    return lexer;
}



module.exports.lexString = lexString;
function lexString(str, emit) {
    let lex = getLexer(str);

    let token = "";
    while ((token = lex.lex())) {
        emit(token);
    }
    
}

module.exports.getAllTokens = getAllTokens;
function getAllTokens(str) {
    let arr = [];
    let emit = function (i) {
        arr.push(i);
    };

    lexString(str, emit);

    return arr;
}





/***/ }),

/***/ "c2a4":
/***/ (function(module, exports, __webpack_require__) {

if ( true && typeof module.exports === "object") module.exports = Lexer;

Lexer.defunct = function (chr) {
    throw new Error("Unexpected character at index " + (this.index - 1) + ": " + chr);
};

function Lexer(defunct) {
    if (typeof defunct !== "function") defunct = Lexer.defunct;

    var tokens = [];
    var rules = [];
    var remove = 0;
    this.state = 0;
    this.index = 0;
    this.input = "";

    this.addRule = function (pattern, action, start) {
        var global = pattern.global;

        if (!global) {
            var flags = "g";
            if (pattern.multiline) flags += "m";
            if (pattern.ignoreCase) flags += "i";
            pattern = new RegExp(pattern.source, flags);
        }

        if (Object.prototype.toString.call(start) !== "[object Array]") start = [0];

        rules.push({
            pattern: pattern,
            global: global,
            action: action,
            start: start
        });

        return this;
    };

    this.setInput = function (input) {
        remove = 0;
        this.state = 0;
        this.index = 0;
        tokens.length = 0;
        this.input = input;
        return this;
    };

    this.lex = function () {
        if (tokens.length) return tokens.shift();

        this.reject = true;

        while (this.index <= this.input.length) {
            var matches = scan.call(this).splice(remove);
            var index = this.index;

            while (matches.length) {
                if (this.reject) {
                    var match = matches.shift();
                    var result = match.result;
                    var length = match.length;
                    this.index += length;
                    this.reject = false;
                    remove++;

                    var token = match.action.apply(this, result);
                    if (this.reject) this.index = result.index;
                    else if (typeof token !== "undefined") {
                        switch (Object.prototype.toString.call(token)) {
                        case "[object Array]":
                            tokens = token.slice(1);
                            token = token[0];
                        default:
                            if (length) remove = 0;
                            return token;
                        }
                    }
                } else break;
            }

            var input = this.input;

            if (index < input.length) {
                if (this.reject) {
                    remove = 0;
                    var token = defunct.call(this, input.charAt(this.index++));
                    if (typeof token !== "undefined") {
                        if (Object.prototype.toString.call(token) === "[object Array]") {
                            tokens = token.slice(1);
                            return token[0];
                        } else return token;
                    }
                } else {
                    if (this.index !== index) remove = 0;
                    this.reject = true;
                }
            } else if (matches.length)
                this.reject = true;
            else break;
        }
    };

    function scan() {
        var matches = [];
        var index = 0;

        var state = this.state;
        var lastIndex = this.index;
        var input = this.input;

        for (var i = 0, length = rules.length; i < length; i++) {
            var rule = rules[i];
            var start = rule.start;
            var states = start.length;

            if ((!states || start.indexOf(state) >= 0) ||
                (state % 2 && states === 1 && !start[0])) {
                var pattern = rule.pattern;
                pattern.lastIndex = lastIndex;
                var result = pattern.exec(input);

                if (result && result.index === lastIndex) {
                    var j = matches.push({
                        result: result,
                        action: rule.action,
                        length: result[0].length
                    });

                    if (rule.global) index = j;

                    while (--j > index) {
                        var k = j - 1;

                        if (matches[j].length > matches[k].length) {
                            var temple = matches[j];
                            matches[j] = matches[k];
                            matches[k] = temple;
                        }
                    }
                }
            }
        }

        return matches;
    }
}


/***/ }),

/***/ "f1dd":
/***/ (function(module, exports, __webpack_require__) {

/*! https://mths.be/utf8js v3.0.0 by @mathias */
;(function(root) {

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	root.version = '3.0.0';
	root.encode = utf8encode;
	root.decode = utf8decode;

}( false ? undefined : exports));


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "VlowPre", function() { return /* reexport */ VlowPre; });
__webpack_require__.d(__webpack_exports__, "VlowCanvas", function() { return /* reexport */ VlowCanvas; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/VlowPre.vue?vue&type=template&id=4c7690e6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VlowCanvas',{attrs:{"library":_vm.library,"nodes":_vm.nodes}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./components/VlowPre.vue?vue&type=template&id=4c7690e6&

// EXTERNAL MODULE: ./node_modules/dirty-json/dirty-json.js
var dirty_json = __webpack_require__("8326");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/VlowCanvas.vue?vue&type=template&id=3293dff7&
var VlowCanvasvue_type_template_id_3293dff7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlow-canvas"},[_c('div',{ref:"vlow-canvas-inner",staticClass:"vlow-canvas-inner"},[_vm._l((_vm.connections),function(connection){return _c('Connection',{key:connection.tgt,staticClass:"vlow-connection",attrs:{"connection":connection,"tick":_vm.tick}})}),_vm._l((_vm.nodes),function(node){return _c(_vm.getComponent(node),{key:node.id,tag:"component",style:({top:node.y+'px', left:node.x+'px'}),attrs:{"proto":_vm.getProto(node.type),"content":node},on:{"start-drag":function($event){return _vm.start_drag(node.id, $event)}}})})],2)])}
var VlowCanvasvue_type_template_id_3293dff7_staticRenderFns = []


// CONCATENATED MODULE: ./components/VlowCanvas.vue?vue&type=template&id=3293dff7&

// CONCATENATED MODULE: ./utils.js
function getRowsInNodeProto(proto) {
  return Math.max(Object.keys(proto.inputs || {}).length + Object.keys(proto.passthroughs || {}).length, Object.keys(proto.outputs || {}).length + Object.keys(proto.collects || {}).length);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Node.vue?vue&type=template&id=23542c9a&
var Nodevue_type_template_id_23542c9a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'vlow-node': true, 'has-left': _vm.hasLeftside, 'has-right': _vm.hasRightside},style:('--rows:'+_vm.rows),attrs:{"rel":_vm.content.id}},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.proto.title)},on:{"mousedown":function($event){$event.preventDefault();return _vm.$emit('start-drag', $event)}}}),_vm._l((_vm.proto.inputs),function(cfg,input,n){return [_c('div',{key:input+'pin',class:'name left row'+n,domProps:{"textContent":_vm._s(cfg.label || input)}}),(_vm.content.node[input].type === 'connection')?_c('div',{key:input+'dot',class:'input left row'+n,attrs:{"rel":input},domProps:{"innerHTML":_vm._s('&middot;')}}):_vm._e(),(_vm.content.node[input].type === 'constant')?_c('div',{key:input+'value',class:'value left row'+n,domProps:{"textContent":_vm._s(_vm.content.node[input].constant.value)}}):_vm._e()]}),_vm._l((_vm.proto.passthroughs),function(cfg,output,n){return [_c('span',{key:output+'pin',class:'name left row'+(n+Object.keys(_vm.proto.inputs).length),domProps:{"textContent":_vm._s(cfg.label || output)}}),_c('div',{key:output+'dot',class:'output left row'+(n+Object.keys(_vm.proto.inputs).length),attrs:{"rel":output},domProps:{"innerHTML":_vm._s('&middot;')}})]}),_vm._l((_vm.proto.outputs),function(cfg,output,n){return [_c('div',{key:output+'pin',class:'name right row'+n,domProps:{"textContent":_vm._s(cfg.label || output)}}),_c('div',{key:output+'dot',class:'output right row'+n,attrs:{"rel":output},domProps:{"innerHTML":_vm._s('&middot;')}})]}),_vm._l((_vm.proto.collects),function(cfg,input,n){return [_c('div',{key:input+'pin',class:'name right row'+(n+Object.keys(_vm.proto.outputs).length),domProps:{"textContent":_vm._s(cfg.label || input)}}),(_vm.content.node[input].type === 'connection')?_c('div',{key:input+'dot',class:'input right row'+(n+Object.keys(_vm.proto.outputs).length),attrs:{"rel":input},domProps:{"innerHTML":_vm._s('&middot;')}}):_vm._e(),(_vm.content.node[input].type === 'constant')?_c('div',{key:input+'value',class:'value right row'+(n+Object.keys(_vm.proto.outputs).length),attrs:{"datasrc":cfg},domProps:{"textContent":_vm._s(_vm.content.node[input].constant.value)}}):_vm._e()]}),(_vm.contentComponent)?_c(_vm.contentComponent,{tag:"component",staticClass:"content",attrs:{"node":_vm.content.node}}):(_vm.proto.passthroughs)?_c('div',{staticClass:"content",style:({width: _vm.content.width+'px', height: _vm.content.height+'px'})}):_vm._e()],2)}
var Nodevue_type_template_id_23542c9a_staticRenderFns = []


// CONCATENATED MODULE: ./components/Node.vue?vue&type=template&id=23542c9a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/custom-content/StringInterpolation.vue?vue&type=template&id=4a39ccd4&
var StringInterpolationvue_type_template_id_4a39ccd4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.node.pattern.constant.value))])}
var StringInterpolationvue_type_template_id_4a39ccd4_staticRenderFns = []


// CONCATENATED MODULE: ./components/custom-content/StringInterpolation.vue?vue&type=template&id=4a39ccd4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/custom-content/StringInterpolation.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var StringInterpolationvue_type_script_lang_js_ = ({
  name: "custom-content-stringInterpolation",
  props: {
    node: Object
  }
});
// CONCATENATED MODULE: ./components/custom-content/StringInterpolation.vue?vue&type=script&lang=js&
 /* harmony default export */ var custom_content_StringInterpolationvue_type_script_lang_js_ = (StringInterpolationvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./components/custom-content/StringInterpolation.vue





/* normalize component */

var component = normalizeComponent(
  custom_content_StringInterpolationvue_type_script_lang_js_,
  StringInterpolationvue_type_template_id_4a39ccd4_render,
  StringInterpolationvue_type_template_id_4a39ccd4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StringInterpolation = (component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Node.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Nodevue_type_script_lang_js_ = ({
  name: "Node",
  components: {
    StringInterpolation: StringInterpolation
  },
  props: {
    proto: Object,
    content: Object
  },
  computed: {
    rows() {
      return getRowsInNodeProto(this.proto);
    },

    hasLeftside() {
      return !!this.proto.inputs || !!this.proto.passthroughs;
    },

    hasRightside() {
      return !!this.proto.outputs || !!this.proto.collects;
    },

    contentComponent() {
      const name = `custom-content-${this.content.type}`;
      const bla = Object.entries(this.$options.components).find(([, comp]) => comp.name === name);
      return bla ? bla[0] : undefined;
    }

  }
});
// CONCATENATED MODULE: ./components/Node.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Nodevue_type_script_lang_js_ = (Nodevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./components/Node.vue?vue&type=style&index=0&lang=scss&
var Nodevue_type_style_index_0_lang_scss_ = __webpack_require__("861d");

// CONCATENATED MODULE: ./components/Node.vue






/* normalize component */

var Node_component = normalizeComponent(
  components_Nodevue_type_script_lang_js_,
  Nodevue_type_template_id_23542c9a_render,
  Nodevue_type_template_id_23542c9a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Node = (Node_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Connection.vue?vue&type=template&id=eec2e540&
var Connectionvue_type_template_id_eec2e540_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.position(_vm.connection, _vm.tick))},[_c('path',{attrs:{"fill":"none","stroke":"white","d":_vm.line(_vm.connection, _vm.tick),"stroke-width":"1"}})])}
var Connectionvue_type_template_id_eec2e540_staticRenderFns = []


// CONCATENATED MODULE: ./components/Connection.vue?vue&type=template&id=eec2e540&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/Connection.vue?vue&type=script&lang=js&
//
//
//
//
//
//
const roundness = 25;
const smoothConnection = true;

function $(selector) {
  return document.querySelector(selector);
}

/* harmony default export */ var Connectionvue_type_script_lang_js_ = ({
  name: "Connection",
  props: {
    connection: {
      src: String,
      tgt: String
    },
    tick: Number
  },
  methods: {
    position: function (foreign_key, i) {
      if (i === 0) return '';
      const src = $(foreign_key.src),
            tgt = $(foreign_key.tgt);

      if (src && tgt) {
        const src_o = src.getBoundingClientRect(),
              tgt_o = tgt.getBoundingClientRect();
        const l = Math.min(src_o.right, tgt_o.left - roundness);
        const r = Math.max(src_o.right + roundness, tgt_o.left);
        const t = Math.min(tgt_o.top + tgt_o.height / 2, src_o.top + src_o.height / 2);
        const w = Math.abs(r - l);
        const h = Math.abs(tgt_o.top - src_o.top) + 2;
        const m = this.$parent.$refs['vlow-canvas-inner'].getBoundingClientRect();
        return {
          left: Math.floor(l - m.left) + "px",
          top: Math.floor(t - m.top) + "px",
          width: Math.floor(w) + "px",
          height: Math.floor(h) + "px"
        };
      } else return {};
    },
    line: function (foreign_key, i) {
      if (i === 0) return '';
      const src = $(foreign_key.src),
            tgt = $(foreign_key.tgt);

      if (src && tgt) {
        const src_o = src.getBoundingClientRect(),
              tgt_o = tgt.getBoundingClientRect();
        const l = Math.min(src_o.right, tgt_o.left - roundness);
        const r = Math.max(src_o.right + roundness, tgt_o.left);
        const w = Math.floor(r - l);
        let h = Math.floor(tgt_o.top - src_o.top);
        let P1, P2, P3, P4;

        if (src_o.right + roundness <= tgt_o.left) {
          if (h > 0) {
            h++;
            P1 = '1,1';
            P2 = roundness + ',1';
            P3 = w - roundness + ',' + h;
            P4 = w + ',' + h;
          } else {
            h *= -1;
            h++;
            P1 = '1,' + h;
            P2 = roundness + ',' + h;
            P3 = w - roundness + ',1';
            P4 = w + ',1';
          }
        } else {
          if (h > 0) {
            h++;
            P1 = w - roundness + ',0';
            P2 = w + ',0';
            P3 = '0,' + h;
            P4 = roundness + ',' + h;
          } else {
            h *= -1;
            h++;
            P1 = w - roundness + ',' + h;
            P2 = w + ',' + h;
            P3 = '0,0';
            P4 = roundness + ',0';
          }
        }

        if (smoothConnection) {
          return "M" + P1 + " C" + P2 + "  " + P3 + "  " + P4;
        } else {
          return "M" + P1 + " L" + P2 + " L" + P3 + " L" + P4;
        }
      } else return '';
    }
  }
});
// CONCATENATED MODULE: ./components/Connection.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Connectionvue_type_script_lang_js_ = (Connectionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/Connection.vue





/* normalize component */

var Connection_component = normalizeComponent(
  components_Connectionvue_type_script_lang_js_,
  Connectionvue_type_template_id_eec2e540_render,
  Connectionvue_type_template_id_eec2e540_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Connection = (Connection_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"f9ab52dc-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/custom-nodes/DecisionTable.vue?vue&type=template&id=74b3cbd2&
var DecisionTablevue_type_template_id_74b3cbd2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlow-node vlow-node-decision-table",style:({'--rows':_vm.rows, '--columns': _vm.columns}),attrs:{"rel":_vm.content.id}},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.proto.title)},on:{"mousedown":function($event){$event.preventDefault();return _vm.$emit('start-drag', $event)}}}),_vm._l((_vm.proto.inputs),function(cfg,input,n){return [_c('div',{key:input+'pin',class:'name left row'+n,domProps:{"textContent":_vm._s(cfg.label || input)}}),(_vm.content.node[input].type === 'connection')?_c('div',{key:input+'dot',class:'input left row'+n,attrs:{"rel":input},domProps:{"innerHTML":_vm._s('&middot;')}}):_vm._e(),(_vm.content.node[input].type === 'constant')?_c('div',{key:input+'value',class:'value left row'+n,domProps:{"textContent":_vm._s(_vm.content.node[input].constant.value)}}):_vm._e()]}),_vm._l((_vm.proto.outputs),function(cfg,output,n){return [_c('div',{key:output+'dot',class:'output right row'+(n + Object.keys(_vm.proto.inputs).length),attrs:{"rel":output},domProps:{"innerHTML":_vm._s('&middot;')}})]}),_vm._l((_vm.content.node.mapping.constant.value),function(column,c){return [_vm._l((column[0]),function(row,r){return [_c('div',{key:c+','+r,class:['row'+r, 'col'+c]},[_vm._v(_vm._s(row?'T':'F'))])]})]})],2)}
var DecisionTablevue_type_template_id_74b3cbd2_staticRenderFns = []


// CONCATENATED MODULE: ./components/custom-nodes/DecisionTable.vue?vue&type=template&id=74b3cbd2&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/custom-nodes/DecisionTable.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DecisionTablevue_type_script_lang_js_ = ({
  name: "custom-node-decisionTable",
  props: {
    proto: Object,
    content: Object
  },
  computed: {
    rows() {
      return getRowsInNodeProto(this.proto);
    },

    columns() {
      return this.content.node.mapping.constant.value.reduce((a, b) => a + b.length, 0);
    }

  }
});
// CONCATENATED MODULE: ./components/custom-nodes/DecisionTable.vue?vue&type=script&lang=js&
 /* harmony default export */ var custom_nodes_DecisionTablevue_type_script_lang_js_ = (DecisionTablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./components/custom-nodes/DecisionTable.vue?vue&type=style&index=0&lang=scss&
var DecisionTablevue_type_style_index_0_lang_scss_ = __webpack_require__("87d9");

// CONCATENATED MODULE: ./components/custom-nodes/DecisionTable.vue






/* normalize component */

var DecisionTable_component = normalizeComponent(
  custom_nodes_DecisionTablevue_type_script_lang_js_,
  DecisionTablevue_type_template_id_74b3cbd2_render,
  DecisionTablevue_type_template_id_74b3cbd2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DecisionTable = (DecisionTable_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/VlowCanvas.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var oldx, oldy;
/* harmony default export */ var VlowCanvasvue_type_script_lang_js_ = ({
  props: {
    library: Array,
    nodes: Array
  },
  components: {
    Connection: Connection,
    Node: Node,
    DecisionTable: DecisionTable
  },

  data() {
    return {
      tick: 0,
      curr_id: null
    };
  },

  methods: {
    start_drag(id, e) {
      this.$el.addEventListener("mousemove", this.do_drag);
      this.$el.addEventListener("mouseup", this.end_drag);
      this.curr_id = id;
      oldx = e.x;
      oldy = e.y;
    },

    do_drag(e) {
      let i = this.nodes.findIndex(node => node.id === this.curr_id);
      this.nodes[i].x += e.x - oldx;
      this.nodes[i].y += e.y - oldy;
      oldx = e.x;
      oldy = e.y;
      this.$nextTick(() => {
        this.tick++;
      });
    },

    end_drag() {
      this.$el.removeEventListener("mousemove", this.do_drag);
      this.$el.removeEventListener("mouseup", this.end_drag);
    },

    getProto(type) {
      return this.library.find(node => node.id === type);
    },

    getComponent(node) {
      const name = `custom-node-${node.type}`;
      var bla = Object.entries(this.$options.components).find(([, comp]) => comp.name === name);
      return bla ? bla[0] : "Node";
    }

  },
  computed: {
    connections() {
      return this.nodes.flatMap(node => Object.entries(node.node).filter(([, {
        type
      }]) => type === "connection").map(([pin, {
        connection
      }]) => ({
        src: `[rel='${connection.source}']>[rel='${connection.pin}']`,
        tgt: `[rel='${node.id}']>[rel='${pin}']`
      })));
    }

  },

  mounted() {
    this.tick++;
    setTimeout(function () {
      this.tick++;
    }, 500);
    const style = getComputedStyle(this.$el);
    const titleHeight = parseInt(style.getPropertyValue('--vlow-node-title-height'));
    const rowHeight = parseInt(style.getPropertyValue('--vlow-node-row-height'));
    const height = Math.max(...this.nodes.map(node => node.y + titleHeight + Math.max(rowHeight * getRowsInNodeProto(this.getProto(node.type)), node.height || 0)));
    this.$el.style.setProperty("--initial-height", height);
  }

});
// CONCATENATED MODULE: ./components/VlowCanvas.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VlowCanvasvue_type_script_lang_js_ = (VlowCanvasvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./components/VlowCanvas.vue?vue&type=style&index=0&lang=scss&
var VlowCanvasvue_type_style_index_0_lang_scss_ = __webpack_require__("0ea7");

// CONCATENATED MODULE: ./components/VlowCanvas.vue






/* normalize component */

var VlowCanvas_component = normalizeComponent(
  components_VlowCanvasvue_type_script_lang_js_,
  VlowCanvasvue_type_template_id_3293dff7_render,
  VlowCanvasvue_type_template_id_3293dff7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VlowCanvas = (VlowCanvas_component.exports);
// EXTERNAL MODULE: ./libraries/std.vlowlib
var std_vlowlib = __webpack_require__("2661");
var std_vlowlib_default = /*#__PURE__*/__webpack_require__.n(std_vlowlib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib??ref--12-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./components/VlowPre.vue?vue&type=script&lang=js&
//
//
//
//



/* harmony default export */ var VlowPrevue_type_script_lang_js_ = ({
  name: "VlowPre",
  components: {
    VlowCanvas: VlowCanvas
  },

  data() {
    let code = "[]";

    if (this.$slots.default && this.$slots.default.length > 0) {
      code = this.$slots.default[0].text;
    }

    return {
      library: std_vlowlib_default.a,
      nodes: Object(dirty_json["parse"])(code)
    };
  }

});
// CONCATENATED MODULE: ./components/VlowPre.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VlowPrevue_type_script_lang_js_ = (VlowPrevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/VlowPre.vue





/* normalize component */

var VlowPre_component = normalizeComponent(
  components_VlowPrevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VlowPre = (VlowPre_component.exports);
// CONCATENATED MODULE: ./index.js



// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
});
//# sourceMappingURL=vue-vlow.umd.js.map